import * as actionType from "../actions/actionType";

const initialState = {
  emailAddress: "",
  emailType: "",
  tableList: [],
  loading: false,
  editLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.EMAIL_UPDATE_STATE:
      return {
        ...state,
        ...action.payload.obj,
      };
    default:
      return state;
  }
};
